import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import * as Mui from '@mui/material';
import * as h from '@utils/helpers';
import { Icon } from '@ts/storybook';
import Link from '../Outputs/Link';
import * as Misc from '../Misc';
import { TextInput, Modal } from '@ts/storybook';

class JsonInput extends React.Component {
  static displayName = 'JsonInput';

  static propTypes = {
    onChange: PropTypes.func.isRequired,
    fDisabled: PropTypes.bool,
  };

  static defaultProps = { fDisabled: false };

  state = {
    fModalShown: false,
    string: '',
  };

  UNSAFE_componentWillMount() {
    return this.changeProp(this.props);
  }

  componentWillReceiveProps(nextProps) {
    return this.changeProp(nextProps);
  }

  changeProp = props => {
    if (props.value === null) {
      this._json = {};
      return this.setState({ string: '' });
    } else if (typeof props.value === 'object') {
      this._json = props.value;
      return this.setState({ string: JSON.stringify(this._json, null, 2) });
    }
    this._json = {};
    return this.setState({ string: '' });
  };

  render() {
    return (
      <>
        <Misc.FlexRow wrap={false}>
          <Misc.FlexRowFlexItem minWidth={80}>
            <TextInput
              disabled
              label={this.props.label}
              rows={this.props.rows}
              rowsMax={this.props.rowsMax}
              value={this.state.string}
              style={this._style()}
              width={this.props.width}
              onChange={this.onChange}
              errorhint={!this.props.fDisabled && !this.isJsonString(this.state.string) ? 'Invalid Json' : undefined}
              placeholder="Enter a Json formatted string"
              multiline
            />
          </Misc.FlexRowFlexItem>
          <Misc.FlexRowItem style={{ width: 50 }}>{this._renderEditButton()}</Misc.FlexRowItem>
        </Misc.FlexRow>
        {this._renderDialog()}
      </>
    );
  }

  _renderEditButton = () => (
    <Mui.IconButton disabled={this.props.fDisabled} onClick={this._handleEditShow} style={{ marginTop: 20 }}>
      <Icon icon="editor-mode-edit" />
    </Mui.IconButton>
  );

  _handleEditShow = () => this.setState({ fModalShown: true });

  _renderDialog = () => {
    return (
      <Modal
        withHeader
        title={'JSON Editor'}
        open={this.state.fModalShown}
        disabled={!this.isJsonString(this.state.string)}
        labelOk="OK"
        onSubmit={() => {
          this._json = JSON.parse(this.state.string);
          this.props.onChange(this._json);
          this.setState({ fModalShown: false });
        }}
        // onFunction={this._handleDialogClear}
        labelCancel="Clear"
        onClose={() => this.setState({ fModalShown: false })}
      >
        <TextInput
          label={this.props.label}
          rows={this.props.rows}
          rowsMax={this.props.rowsMax}
          value={this.state.string}
          style={this._style()}
          width="100%"
          onChange={this.onChange}
          errorText={!this.isJsonString(this.state.string) ? 'Invalid Json' : undefined}
          placeholder="Enter a Json formatted string"
          multiline
        // rows={10}
        />
      </Modal>
    );
  };

  _handleDialogClear = () => this.onChange('dummy', '{}');

  onChange = (ev, value0) => {
    // let string;
    // if (this.isJsonString(value0)) {
    //   this._json = JSON.parse(value0);
    //   string = JSON.stringify(value0, null, 2);
    //   this.props.onChange(this._json);
    // }
    // else
    //  @props.onChange null
    return this.setState({ string: value0 });
  };

  isJsonString = str => {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  };

  _style = () => {
    const style = {
      width: this.props.width,
      display: this.props.fInline ? 'inline-block' : 'block',
    };
    return _.extend(style, this.props.style);
  };
}

class VectorInput extends React.Component {
  static displayName = 'VectorInput';

  static propTypes = {
    onChange: PropTypes.func.isRequired,
    fDisabled: PropTypes.bool,
  };

  static defaultProps = {
    fDisabled: false,
    required: false,
    labelX: 'X',
    labelY: 'Y',
    value: ['', ''],
  };

  render() {
    const value = this.props.value || ['', ''];
    return (
      <div>
        <Misc.FlexRow wrap={false}>
          <Misc.FlexRowFlexItem>
            <TextInput
              type="number"
              isReadOnly={this.props.isReadOnly}
              disabled={this.props.fDisabled}
              label={this.props.labelY}
              value={value[1]}
              style={this._style()}
              width={this.props.width}
              onChange={this.onChange(1)}
              required={this.props.required}
              helper={this.props.helper}
            />
          </Misc.FlexRowFlexItem>
          <Misc.FlexRowFlexItem>
            <TextInput
              type="number"
              isReadOnly={this.props.isReadOnly}
              disabled={this.props.fDisabled}
              label={this.props.labelX}
              value={value[0]}
              style={this._style()}
              width={this.props.width}
              onChange={this.onChange(0)}
              required={this.props.required}
              helper={this.props.helper}
            />
          </Misc.FlexRowFlexItem>
        </Misc.FlexRow>
      </div>
    );
  }

  onChange = index => (ev, value) => {
    let newValue = this.props.value ? [...this.props.value] : ['', ''];
    newValue[index] = value;
    if (newValue[0] === '' && newValue[1] === '') newValue = [null, null];
    return this.props.onChange(newValue);
  };

  //-----------------------------------------------------
  _style = () => {
    const style = {
      width: this.props.width,
      display: this.props.fInline ? 'inline-block' : 'block',
    };
    return _.extend(style, this.props.style);
  };
}

/* interface ExternalLinkProps {
  onChangeLink: PropTypes.func,
  onChangeCaption: PropTypes.func,
  viewFields: PropTypes.bool,
  fDisabled: PropTypes.bool,
  url: PropTypes.string,
  caption: PropTypes.string,
  inLine: PropTypes.bool,
} */
const ExternalLink = props => {
  const { viewFields = true, url = '', caption = '' } = props;

  const _urlFields = () => {
    if (props.inLine) {
      return _inLineFields();
    }
    return (
      <div>
        <TextInput
          isReadOnly={props.isReadOnly}
          label={props.captionLabel || 'URL Caption'}
          placeholder="Caption text to show to users"
          value={caption || ''}
          onChangeValue={props.onChangeCaption}
        />
        <TextInput
          isReadOnly={props.isReadOnly}
          label={props.linkLabel || 'URL Link'}
          placeholder="http link (full URL)"
          value={url || ''}
          onChangeValue={props.onChangeLink}
          errorHint={url !== '' ? h.getTextError('url', url) : undefined}
        />
      </div>
    );
  };

  const _inLineFields = () => (
    <div>
      <Misc.FlexRow>
        <Misc.FlexRowFlexItem>
          <TextInput
            isReadOnly={props.isReadOnly}
            label={props.captionLabel || 'URL Caption'}
            value={caption || ''}
            onChangeValue={props.onChangeCaption}
          />
        </Misc.FlexRowFlexItem>
        <Misc.FlexRowSpacer />
        <Misc.FlexRowFlexItem>
          <TextInput
            isReadOnly={props.isReadOnly}
            label={props.linkLabel || 'URL Link'}
            placeholder="https://"
            value={url || ''}
            onChangeValue={props.onChangeLink}
            errorhint={url !== '' ? h.getTextError('url', url) : undefined}
          />
        </Misc.FlexRowFlexItem>
      </Misc.FlexRow>
    </div>
  );

  const _urlCaption = () => (
    <div style={{ marginTop: '48px' }}>
      <p style={{ fontWeight: 'bold', marginBottom: 0 }}>
        {`${props.linkLabel || 'External link'}: `}
        {caption && (
          <Link href={url} target="_blank" style={{ fontWeight: 'normal', marginLeft: '24px' }}>
            {caption}
          </Link>
        )}
      </p>
    </div>
  );

  if (Boolean(props.isReadOnly && !props.caption && !props.url)) return;
  return (
    <>
      {_urlCaption()}
      {viewFields && _urlFields()}
    </>
  );
};

export {
  JsonInput,
  VectorInput,
  ExternalLink,
};

